/** Bass grooves and arpeggio rhythms the songs share (notation in types.ts). Pure data. */

/** Octave-jumping bass with the snare on the backbeat: the classic C64 bounce. */
export const BOUNCE = 'R . O . S . O . R . O . S . O F';
/** Sixteenth-note bass stabs with a hat between every one: drive for a chorus. */
export const DRIVE = 'R H O H S H O H R H O H S H O H';
/** Half-time: long roots and one snare on beat three, for air. */
export const HALF = 'R . . . . . O . S . . . F . O .';
/** A march, with a snare roll into the next bar. */
export const MARCH = 'R . O . S . O . R . O . S . S S';
/** The in-cave groove: a few roots, a hat, a lot of room. */
export const SPARSE = 'R . . H - . R . H . - . F . H .';

/** 3 + 3 + 2 chord stabs: the bounce that makes a tune skip. */
export const TRESILLO = 'x . . x . . x . x . . x . . x .';
/** A chord struck on every eighth note. */
export const EIGHTHS = 'x . x . x . x . x . x . x . x .';
/** Two quiet stabs a bar. */
export const STABS = 'x . . . - . . . x . - . - . . .';
